// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Package20 from './Package20.tsx';
import Package20Filled from './Package20Filled.tsx';
import Package20CircleFilled from './Package20CircleFilled.tsx';
import Package24 from './Package24.tsx';
import Package24Filled from './Package24Filled.tsx';
import Package24CircleFilled from './Package24CircleFilled.tsx';
import Package40 from './Package40.tsx';
import Package40Filled from './Package40Filled.tsx';
import Package48 from './Package48.tsx';
import Package48Filled from './Package48Filled.tsx';

type PackageProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Package20,
    Package20Filled,
    Package20CircleFilled,
    Package24,
    Package24Filled,
    Package24CircleFilled,
    Package40,
    Package40Filled,
    Package48,
    Package48Filled,
};

const Package: FC<PackageProps> = ({ variation, ...props }) => {
    const variationKey = `Package${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Package" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Package;
